import ModuleNode from './ModuleNode';
import FunctionNode from './FunctionNode';
import FileNode from './FileNode';
import ExternalNode from './ExternalNode';

export { ModuleNode, FunctionNode, FileNode, ExternalNode };

export const nodeTypes = {
  module: ModuleNode,
  function: FunctionNode,
  file: FileNode,
  external: ExternalNode,
};
